module.exports = __webpack_public_path__ + "static/media/icon-congratulation.f6a9c312.png";